<template>
  <navigation>
    <router-view/>
  </navigation>
</template>

<script>
  export default {
    name: "App",
    mounted() {
      var cnzz_protocol = (("https:" == document.location.protocol) ? "https://" : "http://");
      document.write(unescape("%3Cspan id='cnzz_stat_icon_1263620094'%3E%3C/span%3E%3Cscript src='" + cnzz_protocol + "s19.cnzz.com/z_stat.php%3Fid%3D1263620094' type='text/javascript'%3E%3C/script%3E"));
      document.getElementById("cnzz_stat_icon_1263620094").style.display = "none";
    },
    watch: {
      '$route': {
        handler(to, from) {
          setTimeout(() => { //避免首次获取不到window._czc
            if (window._czc) {
              let location = window.location;
              let contentUrl = location.pathname + location.hash;
              let refererUrl = '/';
              // 用于发送某个URL的PV统计请求，
              window._czc.push(['_trackPageview', contentUrl, refererUrl])
            }
          }, 300);
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/App.vue